import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Input, HeaderNavigation } from "mobily-ui-library";
import { ConfigProvider, Form } from "antd";
import { GlobalContext } from "../../context/GlobalContext";
import MapModal from "../../components/MapModal/MapModal";
import Location from '../../assets/Location.svg';
import Arrow from '../../assets/Arrow.svg'
import Mapmarker from '../../assets/mapmarker.svg'
import ListTimer from '../../assets/listtimer.svg'
import ListTimerR from '../../assets/listtimerred.svg'
import ExclamMark from '../../assets/ExclamMark.svg'
import "./FindInBranch.scss"

type Props = {
    callFindInBranchApi: (latLng: any, cityName: string, placeId: string) => void;
    setBranchNotFound: (notFound: boolean) => void;
};

const FindInBranch = ({ callFindInBranchApi, setBranchNotFound }: Props) => {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, addressLine, branchData } = state;
    // cityName, region, latLng, can aslo be recieved from state
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const direction = rtl ? 'rtl' : 'ltr';
    const [mapModal, setMapModal] = useState(false);
    const [address, setAddress] = useState('');
   
    useEffect(() => {
    if (
        branchData &&
        Array.isArray(branchData?.listOfBranches) &&
        branchData?.listOfBranches.length === 0
    ) {
        dispatch({ type: "LOADER", payload: { loading: true } });
        dispatch({ type: "CURRENT_PAGE", payload: { currentPage: "cartPage" } });
        dispatch({  type: "NO_BRANCH_FOUND", payload: { noBranchFound: true } });
        setBranchNotFound(true);
    } }, [branchData]);

    useEffect(() => {
        dispatch({ type: "LOADER", payload: { loading: false } });
    }, [])

    useEffect(() => {
        if (addressLine) {
            setAddress(addressLine);
            form.setFieldsValue({ DeliveryAddress: addressLine });
        }
    }, [addressLine]);

    const handleMapClick = () => {
        setMapModal(true);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        dispatch({ type: "LOADER", payload: { loading: false } })
    }

    const handleMapModalClose = () => {
        setMapModal(false);
    }


    const handleBack = () => {
        dispatch({ type: "CURRENT_PAGE", payload: { currentPage: "cartPage" }});
    }

    const handleAddress = (fullAddress: string, latLng: any, cityName: string, placeId: string) => {
        setAddress(fullAddress);
        dispatch({
            type: "SET_ADDRESS_DETAILS",
            payload: {
                addressLine: fullAddress,
                latLng,
                cityName,
                placeId
            },
        });
        callFindInBranchApi( latLng, cityName, placeId);
        handleMapModalClose();
    };
    const handleDirectionClick = (placeId: string) => {
        const url = `https://www.google.com/maps/dir/?api=1&destination_place_id=${placeId}&destination=${placeId}`;
        window.open(url, "_blank");
        };
        console.log("branchData rtl", rtl);

    return (
        <>
            <div className="container AppleCare__Container">
                <HeaderNavigation
                    rtl={rtl}
                    title={t('Branches')}
                    helpButton={""}
                    onClick={handleBack}
                    // link="https://www.mobily.com.sa/wps/portal/web/personal/am-overview/contact-us"
                />
                <div className="mapInputSection">
                    <ConfigProvider direction={direction}>
                        <Form.Item
                            hasFeedback
                            name='DeliveryAddress'
                            rules={[
                                { required: true, message: t("Delivery_Address_missing") }
                            ]}
                        >
                            <div className={rtl ? 'DD__FormInputIcon DD__FormInputIcon_right' : 'DD__FormInputIcon DD__FormInputIcon_left'} >
                                <Input
                                    value={address}
                                    type="location"
                                    id="ddDeliveryAddress"
                                    className="DD__FormInput"
                                    placeholder={t('select_delivery_address')}
                                    readOnly={true}
                                />
                                <img src={Location} alt='Location' className="location-icon" onClick={handleMapClick} />
                            </div>
                        </Form.Item>
                    </ConfigProvider>
                </div>
                <div className="QtyInfo_Box">
                    <img src={ExclamMark} alt="mark" />
                    <Typography className='Stock_Availability' >{t("stock_availability")} </Typography>

                </div>
                <div className="findInBranch_ButtomSection">
                    <Typography className='findInBranch_Title' >{t("Available_Branches")} </Typography>
                    {/* <div className="findInBranch_Locations">
                        <div className="findInBranch_LocationsDetails">
                            <div>
                                <Typography className='findInBranch_LocationsDetailsTitle' >Mobily Store </Typography>
                                <div className='findInBranch_SubTitle' >
                                    <span> 25km</span>
                                    <span>Open Now</span>
                                </div>
                            </div>
                            <div className="findInBranch_direction" 
                                onClick={() => handleDirectionClick('placeId')}
                            >
                                <img src={Arrow} alt="arrow" />
                            </div>
                        </div>

                    </div> */}
             { (
                branchData?.listOfBranches?.map((branch: any, index: number) => {
                    const isOpen = branch.branchStatus === "Open";
                    const stock = Number(branch?.availableQuantity || 0);

                    return (
                    <div key={index} className="findInBranch_BranchListBox">
                        <div>
                        <Typography className="List_Heading">
                            {branch.branchName}
                        </Typography>

                        <div className={`List_SubTitleBox ${rtl ? "rtl" : ""}`}>

                            <span
                                className="List_MapmarkerMain"
                                style={{
                                    visibility:
                                    branch.branchDistance !== "" &&
                                    branch.branchDistance !== null &&
                                    branch.branchDistance !== undefined
                                        ? "visible"
                                        : "hidden",
                                }}
                                >
                                <img
                                    className="MapMarker"
                                    src={Mapmarker}
                                    alt="Mapmarker"
                                />
                                {branch.branchDistance}
                                </span>

                            <span
                            style={{
                                color: isOpen ? "#055D42" : "#AD1F1F",
                                marginLeft: "12px",
                            }}
                            >
                            <img
                                className="ListTimer"
                                src={isOpen ? ListTimer : ListTimerR}
                                alt="ListTimer"
                            />
                            {isOpen ? t("Open_now") : t("Closed")}
                            </span>

                        </div>
                        </div>

                        <div
                        className="LocationBox"
                        onClick={() =>
                            handleDirectionClick(branch.branchPlaceId)
                        }
                        >
                        {stock > 0 && stock <= 3 && (
                            <span className="ListStock">
                            {t("Only")} {stock} {t("left")}
                            </span>
                        )}

                        <img src={Arrow} alt="arrow" />
                        </div>
                    </div>
                    );
                })
                )}
                </div>

            </div>
            {mapModal && (
                <>
                    <div className="DCMapModal__Backdrop" />
                    <MapModal
                        rtl={rtl}
                        handleAddress={handleAddress}
                        handleMapModalClose={handleMapModalClose}
                    />
                </>
            )}
        </>
    )

}

export default FindInBranch